'use strict';

angular.module('substoreApp.controllers')
    .controller('errorController', ['$scope', '$routeParams', 'sessionData', 'uiservice', 'webtrekk',
        function ($scope, $routeParams, sessionData, uiservice, webtrekk) {

            $scope.data = {};

            $scope.breadcrumb.init("error");

            $scope.$on('$routeChangeStart', function (scope, next, current) {
                if (next.$$route.originalPath.indexOf("/error") < 0)
                    sessionData.fault = undefined;
                sessionData.deleteCurrentSubscription();
            });

            $scope.messageText = '';
            $scope.fault = sessionData.fault;

            if (!$scope.fault)
                $scope.fault = { code: 'UNEXPECTED_ERROR' };

            if ($routeParams.code || !$scope.fault.code)
                $scope.fault.code = $routeParams.code;

            if ($scope.fault.code) {
                // Do we already have a message text for the code given in routeParams?
                if ($scope.fault.code == $routeParams.code && $scope.fault.message != undefined && $scope.fault.message != null && ($scope.fault.code != 'JAVASCRIPT_EXCEPTION' || sessionData.dialogStaticData.dev)) {
                    $scope.messageText = $scope.fault.message;
                } else {
                    // No, fetch it from server
                    uiservice.faultMessage({
                            sessionId: sessionData.sessionId,
                            errorCode: $scope.fault.code,
                            lang: sessionData.dialogStaticData.language,
                            wpId: sessionData.dialogStaticData.wholesalePartnerId
                        },
                        function success(responseData) {
                            // server returned a head/fault data structure via HTTP 200
                            $scope.fault = sessionData.fault = responseData.head.fault;
                            $scope.messageText = responseData.head.fault.message || '';
                            sessionData.storeSessionData();
                        },
                        function error(errorResponse) {
                            // could not fetch message texts from server
                            // set a dummy fault with english internal message text
                            $scope.fault = sessionData.fault = {
                                code: $scope.fault.code,
                                message: 'Internal error (' + $scope.fault.code + '; HTTP ' + errorResponse.status + ' ' + errorResponse.statusText + ')'
                            };
                            $scope.messageText = sessionData.fault.message;
                            sessionData.storeSessionData();
                        });
                }
                $scope.updateTeaser();
            } else {
                $scope.messageText = '';
            }

            // whenever this errorController is called, save the sessionData
            // immediately so that the current errorCode is persisted (in case
            // the user reloads the page)
            sessionData.storeSessionData();

            if (typeof sessionData.fault.positiveError != 'undefined' && sessionData.fault.positiveError == true) {
                webtrekk.track('positive_backend_error', {});
            } else if (typeof sessionData.sessionId == 'undefined' || !sessionData.sessionId) {
                if (typeof sessionData.fault.code != 'undefined' && sessionData.fault.code == 'EXPIRED_SESSION') {
                    // the session expired. Do not track this.
                } else {
                    webtrekk.track('internal_error', {});
                }
            } else {
                webtrekk.track('backend_error', {});
            }

        }]);
